import { jsxs as c, jsx as e } from "react/jsx-runtime";
import { c as f } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import { w as Y } from "./deprecation-Hz1LRzMC.js";
import { T as b } from "./Typography-DjQwU5Xn.js";
import { B as w, I as ee } from "./Input-s7q1Bymv.js";
import { B as D } from "./Badge-CljJSGSb.js";
import * as m from "react";
import { useState as re } from "react";
import { c as te, u as T, h as ae, b as C, d as oe, P as F } from "./index-BwqhVa-H.js";
import { P as se, D as ne } from "./index-B-Qjqgjx.js";
import { c as I, h as le, R as ie, u as ce, F as de, C as ue, a as pe, A as S, b as me } from "./Combination-Te-rCbiT.js";
import { u as fe } from "./index-DfspMmaX.js";
import { P as j } from "./index-Co1YE7s6.js";
import { T as he, a as ve, b as E } from "./Tabs-DWTSgOOn.js";
import { B as ge } from "./bell-CKvlyBv5.js";
import { C as be } from "./Card-1TvXi1hD.js";
const xe = {
  math: "bg-gradient-to-br from-category-math/20 via-category-math/10 to-transparent",
  science: "bg-gradient-to-br from-category-science/20 via-category-science/10 to-transparent",
  arts: "bg-gradient-to-br from-category-arts/20 via-category-arts/10 to-transparent",
  language: "bg-gradient-to-br from-category-language/20 via-category-language/10 to-transparent",
  history: "bg-gradient-to-br from-category-history/20 via-category-history/10 to-transparent",
  default: "bg-gradient-to-br from-muted-foreground/10 via-muted-foreground/5 to-transparent"
}, ye = {
  math: 'before:content-[""] before:absolute before:inset-0 before:bg-[radial-gradient(circle_at_20%_30%,hsl(var(--ds-category-math)/0.15)_2px,transparent_2px),radial-gradient(circle_at_60%_70%,hsl(var(--ds-category-math)/0.1)_3px,transparent_3px),radial-gradient(circle_at_80%_20%,hsl(var(--ds-category-math)/0.12)_2px,transparent_2px)] before:bg-[length:60px_60px]',
  science: 'before:content-[""] before:absolute before:inset-0 before:bg-[linear-gradient(45deg,hsl(var(--ds-category-science)/0.08)_25%,transparent_25%,transparent_75%,hsl(var(--ds-category-science)/0.08)_75%)] before:bg-[length:20px_20px]',
  arts: 'before:content-[""] before:absolute before:inset-0 before:bg-[radial-gradient(ellipse_at_50%_50%,hsl(var(--ds-category-arts)/0.15),transparent_70%)]',
  language: 'before:content-[""] before:absolute before:inset-0 before:bg-[linear-gradient(0deg,hsl(var(--ds-category-language)/0.05)_1px,transparent_1px),linear-gradient(90deg,hsl(var(--ds-category-language)/0.05)_1px,transparent_1px)] before:bg-[length:24px_24px]',
  history: 'before:content-[""] before:absolute before:inset-0 before:bg-[radial-gradient(circle_at_100%_0%,hsl(var(--ds-category-history)/0.2),transparent_50%)]',
  default: 'before:content-[""] before:absolute before:inset-0 before:bg-[radial-gradient(circle_at_50%_50%,hsl(var(--ds-muted-foreground)/0.08),transparent_70%)]'
}, Ne = {
  math: /* @__PURE__ */ e("svg", { className: "w-12 h-12 text-category-math/40", viewBox: "0 0 48 48", fill: "none", stroke: "currentColor", strokeWidth: "2", children: /* @__PURE__ */ e("path", { d: "M12 24h24M24 12v24M8 8l8 8M32 8l8 8M8 40l8-8M32 40l8-8" }) }),
  science: /* @__PURE__ */ c("svg", { className: "w-12 h-12 text-category-science/40", viewBox: "0 0 48 48", fill: "none", stroke: "currentColor", strokeWidth: "2", children: [
    /* @__PURE__ */ e("circle", { cx: "24", cy: "24", r: "8" }),
    /* @__PURE__ */ e("ellipse", { cx: "24", cy: "24", rx: "20", ry: "8" }),
    /* @__PURE__ */ e("ellipse", { cx: "24", cy: "24", rx: "20", ry: "8", transform: "rotate(60 24 24)" }),
    /* @__PURE__ */ e("ellipse", { cx: "24", cy: "24", rx: "20", ry: "8", transform: "rotate(-60 24 24)" })
  ] }),
  arts: /* @__PURE__ */ c("svg", { className: "w-12 h-12 text-category-arts/40", viewBox: "0 0 48 48", fill: "none", stroke: "currentColor", strokeWidth: "2", children: [
    /* @__PURE__ */ e("circle", { cx: "16", cy: "32", r: "4" }),
    /* @__PURE__ */ e("circle", { cx: "32", cy: "20", r: "6" }),
    /* @__PURE__ */ e("path", { d: "M8 16c8-8 24-4 32 8" })
  ] }),
  language: /* @__PURE__ */ e("svg", { className: "w-12 h-12 text-category-language/40", viewBox: "0 0 48 48", fill: "none", stroke: "currentColor", strokeWidth: "2", children: /* @__PURE__ */ e("path", { d: "M8 12h32M8 24h24M8 36h16", strokeLinecap: "round" }) }),
  history: /* @__PURE__ */ c("svg", { className: "w-12 h-12 text-category-history/40", viewBox: "0 0 48 48", fill: "none", stroke: "currentColor", strokeWidth: "2", children: [
    /* @__PURE__ */ e("circle", { cx: "24", cy: "24", r: "16" }),
    /* @__PURE__ */ e("path", { d: "M24 12v12l8 8", strokeLinecap: "round" })
  ] }),
  default: /* @__PURE__ */ c("svg", { className: "w-12 h-12 text-muted-foreground/30", viewBox: "0 0 48 48", fill: "none", stroke: "currentColor", strokeWidth: "2", children: [
    /* @__PURE__ */ e("rect", { x: "8", y: "8", width: "32", height: "32", rx: "4" }),
    /* @__PURE__ */ e("path", { d: "M16 20h16M16 28h12", strokeLinecap: "round" })
  ] })
}, er = ({
  imageUrl: r,
  title: n,
  description: o,
  footer: l,
  actions: t,
  category: a = "default",
  tags: s,
  hoverable: i = !0,
  onClick: d,
  className: u
}) => {
  const h = !!d;
  return /* @__PURE__ */ c(
    "div",
    {
      className: f(
        // Base styles - 2026 super-ellipse radius
        "overflow-hidden rounded-[var(--shape-radius-2xl)] bg-card border border-border-subtle",
        // Modern shadow
        "shadow-sm",
        // Smooth transitions for all states
        "transition-all duration-normal ease-smooth",
        // Hover lift effect
        i && [
          "hover:shadow-lift hover:-translate-y-0.5",
          "active:shadow-md active:translate-y-0"
        ],
        // Clickable styles
        h && "cursor-pointer",
        u
      ),
      onClick: d,
      role: h ? "button" : void 0,
      tabIndex: h ? 0 : void 0,
      children: [
        r ? /* @__PURE__ */ e("div", { className: "relative h-48 w-full overflow-hidden bg-muted", children: /* @__PURE__ */ e(
          "img",
          {
            src: r,
            alt: n,
            className: f(
              "h-full w-full object-cover object-center",
              // Image zoom on hover
              "transition-transform duration-slow ease-smooth",
              i && "group-hover:scale-image-hover"
            )
          }
        ) }) : (
          // Dynamic Thumbnail - Gradient + Pattern based on category
          /* @__PURE__ */ e(
            "div",
            {
              className: f(
                "relative h-48 w-full overflow-hidden",
                xe[a],
                ye[a],
                // Flex center for icon
                "flex items-center justify-center"
              ),
              children: /* @__PURE__ */ e("div", { className: "relative z-10", children: Ne[a] })
            }
          )
        ),
        /* @__PURE__ */ c("div", { className: "p-[calc(var(--density-padding)*1.5)]", children: [
          s && s.length > 0 && /* @__PURE__ */ e("div", { className: "flex flex-wrap gap-[var(--density-gap)] mb-[calc(var(--density-gap)*1.5)]", children: s.map((v, p) => /* @__PURE__ */ e(D, { variant: v.variant || "gray", children: v.label }, p)) }),
          /* @__PURE__ */ e(b, { variant: "h4", className: "mb-2 line-clamp-2", children: n }),
          /* @__PURE__ */ e(b, { variant: "body", className: "text-muted-foreground line-clamp-3", children: o }),
          t && /* @__PURE__ */ c("div", { className: "mt-[calc(var(--density-gap)*2)] flex items-center gap-[calc(var(--density-gap)*1.5)]", children: [
            t.primary && /* @__PURE__ */ e(w, { onClick: t.primary.onClick, children: t.primary.label }),
            t.secondary && /* @__PURE__ */ e(w, { variant: "secondary", onClick: t.secondary.onClick, children: t.secondary.label })
          ] })
        ] }),
        l && /* @__PURE__ */ e("div", { className: "bg-surface-secondary/50 px-6 py-4 border-t border-border-subtle", children: l })
      ]
    }
  );
}, rr = ({
  userEmail: r,
  logo: n,
  onMenuClick: o,
  className: l,
  menuIcon: t,
  searchIcon: a,
  bellIcon: s,
  tenantSwitcher: i,
  userMenu: d,
  notificationSlot: u
}) => (typeof r < "u" && Y({ component: "Header", prop: "userEmail", replacement: "userMenu" }), /* @__PURE__ */ e("header", { className: f("bg-background border-b border-border sticky top-0 z-50", l), children: /* @__PURE__ */ e("div", { className: "mx-auto px-4 sm:px-6 lg:px-8", children: /* @__PURE__ */ c("div", { className: "flex h-16 items-center justify-between gap-x-6", children: [
  /* @__PURE__ */ c("div", { className: "flex items-center gap-x-4", children: [
    /* @__PURE__ */ c(
      "button",
      {
        type: "button",
        className: "-m-2.5 p-2.5 text-muted-foreground lg:hidden",
        onClick: o,
        children: [
          /* @__PURE__ */ e("span", { className: "sr-only", children: "Open sidebar" }),
          t
        ]
      }
    ),
    /* @__PURE__ */ c("div", { className: "flex items-center gap-2", children: [
      n,
      /* @__PURE__ */ e(b, { variant: "h4", className: "hidden md:block", children: "DesignSys" })
    ] }),
    i && /* @__PURE__ */ e("div", { className: "hidden md:block ms-4", children: i })
  ] }),
  /* @__PURE__ */ c("div", { className: "flex flex-1 gap-x-4 self-center lg:gap-x-6", children: [
    /* @__PURE__ */ c("div", { className: "relative flex flex-1", children: [
      /* @__PURE__ */ e("label", { htmlFor: "search-field", className: "sr-only", children: "Search" }),
      /* @__PURE__ */ c("div", { className: "relative w-full max-w-md", children: [
        /* @__PURE__ */ e("div", { className: "pointer-events-none absolute inset-y-0 start-0 flex items-center ps-3", children: a }),
        /* @__PURE__ */ e(
          ee,
          {
            id: "search-field",
            className: "ps-10",
            placeholder: "Search components..."
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ c("div", { className: "flex items-center gap-x-4 lg:gap-x-6", children: [
      u || /* @__PURE__ */ c("button", { type: "button", className: "-m-2.5 p-2.5 text-muted-foreground hover:text-foreground", children: [
        /* @__PURE__ */ e("span", { className: "sr-only", children: "View notifications" }),
        s
      ] }),
      /* @__PURE__ */ e("div", { className: "hidden lg:block lg:h-6 lg:w-px lg:bg-border", "aria-hidden": "true" }),
      d || (r ? /* @__PURE__ */ c("div", { className: "flex items-center gap-x-2", children: [
        /* @__PURE__ */ e("div", { className: "h-8 w-8 rounded-[var(--ds-radius-full)] bg-accent flex items-center justify-center text-primary font-bold text-xs", children: r.slice(0, 2).toUpperCase() }),
        /* @__PURE__ */ e("span", { className: "hidden lg:flex lg:items-center", children: /* @__PURE__ */ e("span", { className: "text-sm font-semibold leading-6 text-foreground", "aria-hidden": "true", children: r }) })
      ] }) : /* @__PURE__ */ e(w, { size: "sm", children: "Log In" }))
    ] })
  ] })
] }) }) }));
var _ = "Popover", [B] = te(_, [
  I
]), P = I(), [Ce, x] = B(_), L = (r) => {
  const {
    __scopePopover: n,
    children: o,
    open: l,
    defaultOpen: t,
    onOpenChange: a,
    modal: s = !1
  } = r, i = P(n), d = m.useRef(null), [u, h] = m.useState(!1), [v, p] = oe({
    prop: l,
    defaultProp: t ?? !1,
    onChange: a,
    caller: _
  });
  return /* @__PURE__ */ e(pe, { ...i, children: /* @__PURE__ */ e(
    Ce,
    {
      scope: n,
      contentId: fe(),
      triggerRef: d,
      open: v,
      onOpenChange: p,
      onOpenToggle: m.useCallback(() => p((y) => !y), [p]),
      hasCustomAnchor: u,
      onCustomAnchorAdd: m.useCallback(() => h(!0), []),
      onCustomAnchorRemove: m.useCallback(() => h(!1), []),
      modal: s,
      children: o
    }
  ) });
};
L.displayName = _;
var z = "PopoverAnchor", we = m.forwardRef(
  (r, n) => {
    const { __scopePopover: o, ...l } = r, t = x(z, o), a = P(o), { onCustomAnchorAdd: s, onCustomAnchorRemove: i } = t;
    return m.useEffect(() => (s(), () => i()), [s, i]), /* @__PURE__ */ e(S, { ...a, ...l, ref: n });
  }
);
we.displayName = z;
var $ = "PopoverTrigger", H = m.forwardRef(
  (r, n) => {
    const { __scopePopover: o, ...l } = r, t = x($, o), a = P(o), s = T(n, t.triggerRef), i = /* @__PURE__ */ e(
      F.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": t.open,
        "aria-controls": t.contentId,
        "data-state": U(t.open),
        ...l,
        ref: s,
        onClick: C(r.onClick, t.onOpenToggle)
      }
    );
    return t.hasCustomAnchor ? i : /* @__PURE__ */ e(S, { asChild: !0, ...a, children: i });
  }
);
H.displayName = $;
var O = "PopoverPortal", [Pe, _e] = B(O, {
  forceMount: void 0
}), G = (r) => {
  const { __scopePopover: n, forceMount: o, children: l, container: t } = r, a = x(O, n);
  return /* @__PURE__ */ e(Pe, { scope: n, forceMount: o, children: /* @__PURE__ */ e(j, { present: o || a.open, children: /* @__PURE__ */ e(se, { asChild: !0, container: t, children: l }) }) });
};
G.displayName = O;
var N = "PopoverContent", V = m.forwardRef(
  (r, n) => {
    const o = _e(N, r.__scopePopover), { forceMount: l = o.forceMount, ...t } = r, a = x(N, r.__scopePopover);
    return /* @__PURE__ */ e(j, { present: l || a.open, children: a.modal ? /* @__PURE__ */ e(Re, { ...t, ref: n }) : /* @__PURE__ */ e(Ae, { ...t, ref: n }) });
  }
);
V.displayName = N;
var ke = ae("PopoverContent.RemoveScroll"), Re = m.forwardRef(
  (r, n) => {
    const o = x(N, r.__scopePopover), l = m.useRef(null), t = T(n, l), a = m.useRef(!1);
    return m.useEffect(() => {
      const s = l.current;
      if (s) return le(s);
    }, []), /* @__PURE__ */ e(ie, { as: ke, allowPinchZoom: !0, children: /* @__PURE__ */ e(
      K,
      {
        ...r,
        ref: t,
        trapFocus: o.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: C(r.onCloseAutoFocus, (s) => {
          var i;
          s.preventDefault(), a.current || (i = o.triggerRef.current) == null || i.focus();
        }),
        onPointerDownOutside: C(
          r.onPointerDownOutside,
          (s) => {
            const i = s.detail.originalEvent, d = i.button === 0 && i.ctrlKey === !0, u = i.button === 2 || d;
            a.current = u;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: C(
          r.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), Ae = m.forwardRef(
  (r, n) => {
    const o = x(N, r.__scopePopover), l = m.useRef(!1), t = m.useRef(!1);
    return /* @__PURE__ */ e(
      K,
      {
        ...r,
        ref: n,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var s, i;
          (s = r.onCloseAutoFocus) == null || s.call(r, a), a.defaultPrevented || (l.current || (i = o.triggerRef.current) == null || i.focus(), a.preventDefault()), l.current = !1, t.current = !1;
        },
        onInteractOutside: (a) => {
          var d, u;
          (d = r.onInteractOutside) == null || d.call(r, a), a.defaultPrevented || (l.current = !0, a.detail.originalEvent.type === "pointerdown" && (t.current = !0));
          const s = a.target;
          ((u = o.triggerRef.current) == null ? void 0 : u.contains(s)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && t.current && a.preventDefault();
        }
      }
    );
  }
), K = m.forwardRef(
  (r, n) => {
    const {
      __scopePopover: o,
      trapFocus: l,
      onOpenAutoFocus: t,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: s,
      onEscapeKeyDown: i,
      onPointerDownOutside: d,
      onFocusOutside: u,
      onInteractOutside: h,
      ...v
    } = r, p = x(N, o), y = P(o);
    return ce(), /* @__PURE__ */ e(
      de,
      {
        asChild: !0,
        loop: !0,
        trapped: l,
        onMountAutoFocus: t,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ e(
          ne,
          {
            asChild: !0,
            disableOutsidePointerEvents: s,
            onInteractOutside: h,
            onEscapeKeyDown: i,
            onPointerDownOutside: d,
            onFocusOutside: u,
            onDismiss: () => p.onOpenChange(!1),
            children: /* @__PURE__ */ e(
              ue,
              {
                "data-state": U(p.open),
                role: "dialog",
                id: p.contentId,
                ...y,
                ...v,
                ref: n,
                style: {
                  ...v.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), q = "PopoverClose", Oe = m.forwardRef(
  (r, n) => {
    const { __scopePopover: o, ...l } = r, t = x(q, o);
    return /* @__PURE__ */ e(
      F.button,
      {
        type: "button",
        ...l,
        ref: n,
        onClick: C(r.onClick, () => t.onOpenChange(!1))
      }
    );
  }
);
Oe.displayName = q;
var Me = "PopoverArrow", Ee = m.forwardRef(
  (r, n) => {
    const { __scopePopover: o, ...l } = r, t = P(o);
    return /* @__PURE__ */ e(me, { ...t, ...l, ref: n });
  }
);
Ee.displayName = Me;
function U(r) {
  return r ? "open" : "closed";
}
var De = L, Te = H, Fe = G, W = V;
const Ie = De, Se = Te, Z = m.forwardRef(({ className: r, align: n = "center", sideOffset: o = 4, ...l }, t) => /* @__PURE__ */ e(Fe, { children: /* @__PURE__ */ e(
  W,
  {
    ref: t,
    align: n,
    sideOffset: o,
    className: f(
      "z-50 w-72 rounded-[var(--ds-radius-md)] border bg-[var(--ds-color-bg-surface-default)] p-4 text-[var(--ds-color-fg-default)] shadow-elevation-2 outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      r
    ),
    ...l
  }
) }));
Z.displayName = W.displayName;
const tr = ({
  notifications: r,
  onMarkAsRead: n,
  onMarkAllAsRead: o,
  onNotificationClick: l,
  onLoadMore: t,
  hasMore: a = !1,
  isLoadingMore: s = !1,
  className: i
}) => {
  const d = r.filter((p) => !p.read).length, [u, h] = re("all"), v = r.filter((p) => u === "all" ? !0 : u === "unread" ? !p.read : !0);
  return /* @__PURE__ */ c(Ie, { children: [
    /* @__PURE__ */ e(Se, { asChild: !0, children: /* @__PURE__ */ c(
      "button",
      {
        type: "button",
        className: f(
          "relative -m-2.5 p-2.5 text-[var(--ds-color-fg-placeholder)] hover:text-[var(--ds-color-fg-subtle)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ds-color-border-primary)] rounded-[var(--ds-radius-md)]",
          i
        ),
        "aria-label": `Notifications ${d > 0 ? `(${d} unread)` : ""}`,
        children: [
          /* @__PURE__ */ e(ge, { className: "h-6 w-6" }),
          d > 0 && /* @__PURE__ */ e("span", { className: "absolute top-2 right-2 block h-2.5 w-2.5 transform translate-x-1/2 -translate-y-1/2 rounded-full bg-[var(--ds-color-bg-danger-default)] ring-2 ring-[var(--ds-color-bg-surface-default)]", children: /* @__PURE__ */ e("span", { className: "sr-only", children: "New notifications" }) })
        ]
      }
    ) }),
    /* @__PURE__ */ c(Z, { className: "w-80 p-0 sm:w-96", align: "end", sideOffset: 5, children: [
      /* @__PURE__ */ c("div", { className: "flex items-center justify-between px-4 py-3 border-b border-[var(--ds-color-border-muted)]", children: [
        /* @__PURE__ */ e(b, { variant: "body", className: "font-semibold text-base", children: "Notifications" }),
        d > 0 && /* @__PURE__ */ e(
          w,
          {
            variant: "ghost",
            size: "sm",
            onClick: o,
            className: "text-xs h-auto py-1 px-2",
            "aria-label": "Mark all as read",
            children: "Mark all as read"
          }
        )
      ] }),
      /* @__PURE__ */ c(he, { defaultValue: "all", value: u, onValueChange: h, className: "w-full", children: [
        /* @__PURE__ */ c(ve, { className: "w-full justify-start rounded-none border-b border-[var(--ds-color-border-muted)] bg-transparent p-0", children: [
          /* @__PURE__ */ e(
            E,
            {
              value: "all",
              className: "rounded-none border-b-2 border-transparent px-4 py-2 text-sm font-medium data-[state=active]:border-[var(--ds-color-border-primary)] data-[state=active]:text-[var(--ds-color-fg-primary)]",
              children: "All"
            }
          ),
          /* @__PURE__ */ e(
            E,
            {
              value: "unread",
              className: "rounded-none border-b-2 border-transparent px-4 py-2 text-sm font-medium data-[state=active]:border-[var(--ds-color-border-primary)] data-[state=active]:text-[var(--ds-color-fg-primary)]",
              children: "Unread"
            }
          )
        ] }),
        /* @__PURE__ */ c(
          "div",
          {
            className: "max-h-[400px] overflow-y-auto",
            role: "log",
            "aria-live": "polite",
            "aria-label": "Notifications list",
            tabIndex: 0,
            children: [
              v.length === 0 ? /* @__PURE__ */ e("div", { className: "p-8 text-center text-[var(--ds-color-fg-muted)]", children: /* @__PURE__ */ e(b, { variant: "small", children: "No notifications found." }) }) : /* @__PURE__ */ e("ul", { className: "divide-y divide-[var(--ds-color-border-muted)]", children: v.map((p) => /* @__PURE__ */ c("li", { className: f(
                "relative flex flex-col gap-1 p-4 hover:bg-[var(--ds-color-bg-surface-hover)] transition-colors focus-within:bg-[var(--ds-color-bg-surface-hover)]",
                !p.read && "bg-[var(--ds-color-bg-surface-active)]/10"
              ), children: [
                /* @__PURE__ */ c("div", { className: "flex items-start justify-between gap-2", children: [
                  /* @__PURE__ */ c(
                    "button",
                    {
                      onClick: () => l(p.id),
                      className: "text-left flex-1 focus:outline-none focus:underline",
                      children: [
                        /* @__PURE__ */ e(b, { variant: "small", className: f("font-medium", !p.read && "text-[var(--ds-color-fg-default)]"), children: p.title }),
                        /* @__PURE__ */ e(b, { variant: "small", className: "text-[var(--ds-color-fg-muted)] line-clamp-2 mt-0.5", children: p.description })
                      ]
                    }
                  ),
                  !p.read && /* @__PURE__ */ e(
                    "button",
                    {
                      onClick: () => n(p.id),
                      className: "mt-1 flex-shrink-0 text-[var(--ds-color-fg-primary)] hover:text-[var(--ds-color-fg-primary-active)] p-1 rounded-[var(--ds-radius-full)] hover:bg-[var(--ds-color-bg-surface-active)]",
                      title: "Mark as read",
                      "aria-label": "Mark as read",
                      children: /* @__PURE__ */ e("span", { className: "block h-2 w-2 rounded-[var(--ds-radius-full)] bg-current" })
                    }
                  )
                ] }),
                /* @__PURE__ */ e("span", { className: "text-xs text-[var(--ds-color-fg-placeholder)]", children: p.timestamp })
              ] }, p.id)) }),
              a && /* @__PURE__ */ e("div", { className: "p-2 text-center border-t border-[var(--ds-color-border-muted)]", children: /* @__PURE__ */ e(
                w,
                {
                  variant: "ghost",
                  size: "sm",
                  onClick: t,
                  disabled: s,
                  className: "w-full",
                  children: s ? "Loading..." : "Load More"
                }
              ) })
            ]
          }
        )
      ] })
    ] })
  ] });
}, je = {
  square: "aspect-square",
  "4/3": "aspect-[4/3]",
  "3/4": "aspect-[3/4]",
  "16/9": "aspect-[16/9]",
  "3/2": "aspect-[3/2]"
}, ar = ({
  thumbnail: r,
  thumbnailFallback: n,
  thumbnailAspectRatio: o = "3/4",
  title: l,
  description: t,
  badges: a,
  secondaryText: s,
  hoverActions: i,
  onClick: d,
  as: u,
  wrapperProps: h,
  selected: v,
  hoverable: p = !0,
  footer: y,
  compact: k = !1,
  className: J,
  ...Q
}) => {
  const X = () => {
    d && !u && d();
  }, M = /* @__PURE__ */ e(
    "div",
    {
      className: f(d && !u && "cursor-pointer"),
      onClick: X,
      role: d && !u ? "button" : void 0,
      tabIndex: d && !u ? 0 : void 0,
      onKeyDown: d && !u ? (g) => {
        (g.key === "Enter" || g.key === " ") && (g.preventDefault(), d());
      } : void 0,
      children: /* @__PURE__ */ c(
        be,
        {
          className: f(
            "group h-full overflow-hidden",
            p && "transition-all hover:shadow-lg hover:-translate-y-1",
            v && "ring-2 ring-primary",
            J
          ),
          ...Q,
          children: [
            /* @__PURE__ */ c(
              "div",
              {
                className: f(
                  "bg-gradient-to-br from-muted to-muted/50 relative overflow-hidden",
                  je[o]
                ),
                children: [
                  r ? /* @__PURE__ */ e("div", { className: "absolute inset-0", children: r }) : n ? /* @__PURE__ */ e("div", { className: "absolute inset-0 flex items-center justify-center", children: n }) : null,
                  i && i.length > 0 && /* @__PURE__ */ e("div", { className: "absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors", children: /* @__PURE__ */ e("div", { className: "absolute bottom-2 right-2 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity", children: i.map((g, R) => /* @__PURE__ */ e(
                    "button",
                    {
                      onClick: (A) => {
                        A.preventDefault(), A.stopPropagation(), g.onClick(A);
                      },
                      className: f(
                        "flex h-8 w-8 items-center justify-center rounded-full bg-white shadow-md transition-colors",
                        g.active ? g.activeClassName || "text-primary" : "text-muted-foreground hover:text-primary"
                      ),
                      "aria-label": g.label,
                      children: g.icon
                    },
                    R
                  )) }) })
                ]
              }
            ),
            /* @__PURE__ */ c("div", { className: f("p-3", k && "p-2"), children: [
              /* @__PURE__ */ e(
                b,
                {
                  variant: "body",
                  className: f(
                    "font-medium text-foreground line-clamp-1 group-hover:text-primary transition-colors",
                    k && "text-sm"
                  ),
                  children: l
                }
              ),
              t && /* @__PURE__ */ e(
                b,
                {
                  variant: "small",
                  className: f(
                    "text-muted-foreground mt-1 line-clamp-2",
                    k && "line-clamp-1"
                  ),
                  children: t
                }
              ),
              (a || s) && /* @__PURE__ */ c("div", { className: "flex items-center gap-2 mt-2 flex-wrap", children: [
                a == null ? void 0 : a.map((g, R) => /* @__PURE__ */ e(D, { variant: g.variant || "blue", className: "text-xs", children: g.label }, R)),
                s && /* @__PURE__ */ e("span", { className: "text-xs text-muted-foreground", children: s })
              ] })
            ] }),
            y && /* @__PURE__ */ e("div", { className: "px-3 pb-3 pt-0", children: y })
          ]
        }
      )
    }
  );
  return u ? /* @__PURE__ */ e(u, { ...h, className: "block", children: M }) : M;
};
export {
  er as C,
  rr as H,
  ar as M,
  tr as N
};
